import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { IconButton } from "../../IconButton";

export const MarkAsReadButton = ({
  areNotificationsBeingMarkedAsRead,
  onClick,
}: {
  areNotificationsBeingMarkedAsRead: boolean;
  onClick: () => void;
}) => {
  if (areNotificationsBeingMarkedAsRead) {
    return (
      <div className="bg-secondary flex h-6 w-6 items-center justify-center rounded">
        <Icon type="live-spinner" className="h-4 w-4 animate-spin" />
      </div>
    );
  }

  return (
    <TippyV2 interactive={false} content={t("header_v3.mark_all_as_read")}>
      <IconButton
        name="16-mark-as-read"
        onClick={onClick}
        ariaLabel={t("header_v3.mark_all_as_read")}
        iconClassName="!text-dark"
      />
    </TippyV2>
  );
};
